import { useState } from "react";
import LogContext from "./LogContext";
import React from 'react'

export default function LogState(props) {
    // import useContext and LogState in the constructor of useContext
    // and then use the function defined in the LogState in the function 
    // along with the parameters defined in the LogState functions
    const [product,setProduct]=useState('');
    const [category,setCategory]=useState('All');
    const [subcategory,setSubcategory]=useState('All');
    const [user,setUser]=useState({});
    const [cart,setCart]=useState([]);
    const [selectedCoupon, setSelectedCoupon] = useState();

    const updateProduct=(product)=>{
        setProduct(product);
    }
    const updateCategory=(category)=>{
        setCategory(category)
    }

   const updateSubcategory=(subcategory)=>{
        setSubcategory(subcategory);
   };
   const updateUser=(user)=>{
    setUser(user);
   }
   const updateCart=(product)=>{
    setCart(prev=> [...prev,product])
   }
   const updateCoupon = (coupon)=>{
    setSelectedCoupon(coupon)
   }
  return (
    <LogContext.Provider value={{product,updateProduct,category,updateCategory,subcategory,updateSubcategory,user,updateUser,cart,updateCart, selectedCoupon, updateCoupon}}>
        {props.children}
    </LogContext.Provider>
    )
}